import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import Toggle from 'material-ui/Toggle';
import IconDelete from 'material-ui/svg-icons/action/delete';

import DeletePlaceholderEmbed from '../DeletePlaceholderEmbed/DeletePlaceholderEmbed';

import mergeStates from '../../helpers/mergeStates';

import classes from './FormBankEmbed.scss';

class FormBankEmbed extends React.Component {
  toggleAccountNrActive = isInputChecked => {
    this.props.onChange({
      ...this.props.bank,
      account_nr_active: isInputChecked,
    });
  };

  handleChange = e => {
    const nextState = mergeStates(e, this.props.bank);
    this.props.onChange(nextState);
  };

  setDeleteFlag = (event, unset) => {
    if (typeof unset !== 'undefined' && unset === true) {
      this.props.onChange({ ...this.props.bank, delete_this_bank: null });
    } else {
      this.props.onChange({
        ...this.props.bank,
        delete_this_bank: this.props.bank.id,
      });
    }
  };

  render() {
    let heading = 'Neues Konto anlegen';
    let deleteButtonText = 'Konto';
    if (
      typeof this.props.bank.name !== 'undefined' &&
      this.props.bank.name.length
    ) {
      heading = this.props.bank.name;
      deleteButtonText = heading;
    }

    if (
      typeof this.props.bank.delete_this_bank !== 'undefined' &&
      this.props.bank.delete_this_bank
    ) {
      return (
        <DeletePlaceholderEmbed
          name={deleteButtonText}
          onCancel={e => this.setDeleteFlag(e, true)}
        />
      );
    }

    return (
      <div className={classes.form}>
        <Card className={classes.card}>
          <CardHeader
            title={heading}
            actAsExpander
            showExpandableButton
            className={classes.cardHeader}
            titleStyle={{
              color: '#4a4a4a',
              fontWeight: 700,
              fontSize: '18px',
            }}
          />
          <CardText expandable className={classes.cardText}>
            <div className="row">
              <div className="col-xs-12 col-sm-4">
                <label className="simpl-label" htmlFor="name">
                  Bankname
                </label>
              </div>
              <div className="col-xs-12 col-sm-8">
                <input
                  name="name"
                  value={this.props.bank.name}
                  onChange={e => this.handleChange(e)}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-xs-12 col-sm-4">
                <label className="simpl-label" htmlFor="owner">
                  Kontoinhaber
                </label>
              </div>
              <div className="col-xs-12 col-sm-8">
                <input
                  name="owner"
                  value={this.props.bank.owner}
                  onChange={e => this.handleChange(e)}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-xs-12 col-sm-4">
                <label className="simpl-label" htmlFor="iban">
                  IBAN
                </label>
              </div>
              <div className="col-xs-12 col-sm-8">
                <input
                  name="iban"
                  value={this.props.bank.iban}
                  onChange={e => this.handleChange(e)}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-xs-12 col-sm-4">
                <label className="simpl-label" htmlFor="bic">
                  BIC
                </label>
              </div>
              <div className="col-xs-12 col-sm-8">
                <input
                  name="bic"
                  value={this.props.bank.bic}
                  onChange={e => this.handleChange(e)}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-xs-12 col-sm-4">
                <label className="simpl-label" htmlFor="account_nr_active">
                  Kontonr. eintragen
                </label>
              </div>
              <div className="col-xs-12 col-sm-8">
                <Toggle
                  label=""
                  toggled={this.props.bank.account_nr_active}
                  onToggle={(event, isInputChecked) =>
                    this.toggleAccountNrActive(isInputChecked)
                  }
                />
              </div>
            </div>

            <div
              className={
                this.props.bank.account_nr_active ? classes.show : classes.hide
              }
            >
              <div className="row">
                <div className="col-xs-12 col-sm-4">
                  <label className="simpl-label" htmlFor="account_nr">
                    Kontonummer
                  </label>
                </div>
                <div className="col-xs-12 col-sm-8">
                  <input
                    name="account_nr"
                    value={this.props.bank.account_nr}
                    onChange={e => this.handleChange(e)}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-xs-12 col-sm-4">
                  <label className="simpl-label" htmlFor="bank_identifier">
                    Bankleitzahl
                  </label>
                </div>
                <div className="col-xs-12 col-sm-8">
                  <input
                    name="bank_identifier"
                    value={this.props.bank.bank_identifier}
                    onChange={e => this.handleChange(e)}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-xs-12 col-sm-4">
                <label className="simpl-label" htmlFor="sepa">
                  SEPA
                </label>
              </div>
              <div className="col-xs-12 col-sm-8">
                <input
                  name="sepa"
                  value={this.props.bank.sepa}
                  onChange={e => this.handleChange(e)}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-xs-12 col-sm-4">
                <label className="simpl-label" htmlFor="sepa_notes">
                  SEPA-Zusatzinformationen
                </label>
              </div>
              <div className="col-xs-12 col-sm-8">
                <textarea
                  name="sepa_notes"
                  value={this.props.bank.sepa_notes}
                  rows="4"
                  cols="12"
                  onChange={e => this.handleChange(e)}
                />
              </div>
            </div>

            <div className={classes.cardFooter}>
              <span
                className={classes.cardButton}
                onMouseDown={e => this.setDeleteFlag(e)}
              >
                <IconDelete /> {deleteButtonText} entfernen
              </span>
            </div>
          </CardText>
        </Card>
      </div>
    );
  }
}

FormBankEmbed.propTypes = {
  bank: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default FormBankEmbed;



// WEBPACK FOOTER //
// ./src/components/FormBankEmbed/FormBankEmbed.js